var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMerge = function SvgMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.503 4.926a2 2 0 1 0-1 0v6.142a2 2 0 1 0 1 0zm-1.5-1.93a1 1 0 1 1 2 0 1 1 0 0 1-2 0m2 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9 5.09.707-.708-.793-.882H11.5v7.568a2 2 0 1 0 1 0V3.5a1 1 0 0 0-1-1H8.914l.793-.793L9 1 7 3zm3.832 8.462a1 1 0 1 0-1.663-1.11 1 1 0 0 0 1.662 1.11",
    clipRule: "evenodd"
  })));
};
export default SvgMerge;